module.exports = __webpack_public_path__ + "static/mobile-hero-bus-open-data-package-8a3d277c8be88c344205bf18ac6d444d.jpg";